import { Geometry, TextStyle } from "../../drawing";
import { IItem, instanceOfIItem } from "./IItem";
import { AutoNotePageKinds } from "../AutoNotePageKinds";

export interface IFontSizeAutoAdjustable extends IItem {
  id: string;
  name: string;
  enabledAutoAdjustFontSize: boolean;
  geometry: Geometry;
  value: any;
  textStyle: TextStyle;
  setText(text: string): void;
  autoNotePageSize: number;
  autoNotePageKind: AutoNotePageKinds;
  displayName?: string;
  isEmpty: boolean;
  adjustFontSize(): void;
  text(): string;
  isFreeInputable?: boolean;
  isVisible: boolean;
  isMultiLine?: boolean;
}

export function instanceOfIFontSizeAutoAdjustable(instance: any): instance is IFontSizeAutoAdjustable {
  return instance
    && (instance.enabledAutoAdjustFontSize !== undefined)
    && (instance.geometry !== undefined)
    && (instance.textStyle !== undefined)
    && (instance.setText !== undefined)
    && (instance.text !== undefined)
    && (instance.isEmpty !== undefined)
    && (instance.isVisible !== undefined)
    && instanceOfIItem(instance);
}
